import React from "react";
import { Link } from "react-router-dom";
import { PERFORMANCE_ACTS, DECOR_CONCEPTS } from "../data/content";
import { SectionHeader, Reveal } from "./Ornament";

const Tile = ({ item, testid, index }) => (
  <Reveal delay={Math.min(index + 1, 6)}>
    <Link to={`/acts/${item.id}`} className="tile group aspect-[3/4] block" data-testid={testid}>
      <img src={item.image} alt={item.name} className="w-full h-full object-cover" />
      <div className="tile-cover-overlay" />
      <div className="tile-caption">
        <p className="kicker">Signature Act</p>
        <h3 className="mt-3 font-serif text-[26px] leading-[1.05] text-[var(--lu-ivory)]">
          {item.name}
        </h3>
        <p className="mt-3 text-[13px] leading-[1.7] text-ivory-75 font-light">
          {item.desc}
        </p>
      </div>
    </Link>
  </Reveal>
);

const WorldTile = () => null;
void WorldTile;


export default function Services() {
  return (
    <section id="services" data-testid="services-section">
      {/* --- Entertainment Performance Acts (Dark editorial) --- */}
      <div className="relative bg-[var(--lu-black)] section-y grain overflow-hidden">
        <div className="container-lux">
          <SectionHeader
            kicker="Our Art"
            title="Representations"
            italicTitle="World Level"
            sub="We turn events into exceptional experiences through performance, creativity and immersive storytelling."
            className="mb-24"
            light
          />

          <div
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-10"
            data-testid="performance-acts-grid"
          >
            {PERFORMANCE_ACTS.map((item, i) => (
              <Tile key={item.id} item={item} testid={`act-${item.id}`} index={i} />
            ))}
          </div>
        </div>
      </div>

      {/* --- Themed Decoration + Disco-Tech Reel (Dark) --- */}
      <div className="relative bg-[var(--lu-black)] section-y grain">
        <div className="container-lux grid grid-cols-1 lg:grid-cols-12 gap-16 items-start">
          {/* Disco-Tech reel block */}
          <Reveal className="lg:col-span-5" data-testid="disco-tech-block">
            <p className="kicker">Signature Reel</p>
            <h3 className="mt-6 h-editorial text-[42px] lg:text-[56px] text-[var(--lu-ivory)] leading-[0.95]">
              Disco-Tech <span className="italic text-[var(--lu-gold)]">Act</span>
            </h3>
            <div className="deco-line-solid my-10 max-w-[220px]" />
            <p className="text-[15px] leading-[1.85] text-ivory-75 font-light max-w-md">A cinematic futuristic-space performance loop — a taste of technology
              and the atmosphere we set for immersive evenings.</p>
            <div className="mt-12 aspect-[16/10] tile" data-testid="disco-tech-video-wrap">
              <video
                className="w-full h-full object-cover"
                autoPlay
                muted
                loop
                playsInline
                preload="metadata"
                poster="/generated/disco-80s-4.jpg"
                data-testid="disco-tech-video"
              >
                <source src="/generated/disco-tech.mp4" type="video/mp4" />
              </video>
              <div className="pointer-events-none absolute inset-0 border border-[var(--lu-gold)]/40" />
              <div className="absolute bottom-4 left-4 flex items-center gap-2 px-3 py-1.5 bg-[var(--lu-black)]/60 backdrop-blur-md border border-[var(--lu-gold)]/40">
                <span className="w-1.5 h-1.5 rounded-full bg-[var(--lu-gold)] play-pulse" />
                <span className="font-micro text-[9px] text-gold-light-90">Reel · Disco-Tech Act</span>
              </div>
            </div>
          </Reveal>

          {/* Decor block */}
          <Reveal delay={2} className="lg:col-span-7" data-testid="decor-concepts">
            <p className="kicker">The Space</p>
            <h3 className="mt-6 h-editorial text-[42px] lg:text-[56px] text-[var(--lu-ivory)] leading-[0.95]">Thematically<span className="italic text-[var(--lu-gold)]">Decoration Concepts</span>
            </h3>
            <div className="deco-line-solid my-10 max-w-[220px]" />
            <div className="aspect-[16/9] tile">
              <img
                src="/generated/golden-performer-closeup.jpg"
                alt="Themed decoration"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="mt-10 grid grid-cols-2 sm:grid-cols-5 gap-4">
              {DECOR_CONCEPTS.map((d, i) => (
                <div
                  key={d}
                  className="border border-[var(--lu-gold)]/40 p-5 text-center hover:border-[var(--lu-gold)] hover:-translate-y-1 transition-all duration-500"
                  data-testid={`decor-${i}`}
                >
                  <p className="font-serif text-[19px] text-[var(--lu-ivory)] leading-tight">{d}</p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
